import React from 'react';

const NaturalIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 5 6.2 3.2c-1-.3-2 .5-1.7 1.4l1.3 4.3c.2.7.7 1.3 1.4 1.7l4.3 1.3c.9.3 1.7-.7 1.4-1.7L12 5Z" />
    <path d="M12 5 17.8 6.8c1 .3 2-.5 1.7-1.4l-1.3-4.3c-.2-.7-.7-1.3-1.4-1.7L12.5 1c-.9-.3-1.7.7-1.4 1.7L12 5Z" />
    <path d="M12 5 6.2 6.8c-1 .3-1.5 1.5-.8 2.2l4.3 4.3c.7.7 1.8.2 2.2-.8L12 5Z" />
    <path d="m15 14-2 2" />
    <path d="M12 22c-5.523 0-10-4.477-10-10 0-2.347.81-4.49 2.16-6.22" />
  </svg>
);

export default NaturalIcon;